export default __webpack_public_path__ + "static/media/about.9e9f3795.jpg";